<template>
  <!-- Phase 2 - US-013: Fee Master Configuration -->
  <div>
    <b-card header="Fee Master Configuration" class="mb-3">
      <div v-if="isLoading" class="text-center py-3">
        <b-spinner small></b-spinner> Loading...
      </div>
      <b-table
        v-else
        :items="fees"
        :fields="fields"
        striped
        small
        responsive
        hover
      >
        <template #cell(sno)="{ index }">
          {{ index + 1 }}
        </template>
        <template #cell(amount)="{ value }">
          Rs. {{ Number(value || 0).toLocaleString("en-IN") }}
        </template>
        <template #cell(is_active)="{ value }">
          <b-badge :variant="value ? 'success' : 'secondary'">
            {{ value ? "Active" : "Inactive" }}
          </b-badge>
        </template>
        <template #cell(actions)="{ item }">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="editFee(item)"
            v-if="isAdmin"
          >
            <b-icon icon="pencil"></b-icon> Edit
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Edit Fee Modal -->
    <b-modal
      v-model="showModal"
      title="Edit Fee Amount"
      centered
      hide-footer
      size="md"
    >
      <form-wrapper @submit="saveFee">
        <b-row>
          <b-col cols="12">
            <input-field
              :value="editingFee.fee_description"
              label="Fee Type"
              disabled
            ></input-field>
          </b-col>
          <b-col cols="12">
            <input-field
              :value="editingFee.organ_type || 'All'"
              label="Organ Type"
              disabled
            ></input-field>
          </b-col>
          <b-col cols="12">
            <input-field
              v-model="editingFee.amount"
              label="Amount (Rs.)"
              rules="required|integer"
              type="number"
            ></input-field>
          </b-col>
          <b-col cols="12">
            <date-picker
              v-model="editingFee.effective_from"
              label="Effective From"
              rules="required"
            ></date-picker>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="outline-danger" @click="showModal = false"
            >Cancel</b-button
          >
          <b-button class="ms-3" variant="success" type="submit"
            >Save</b-button
          >
        </div>
      </form-wrapper>
    </b-modal>
  </div>
</template>

<script>
import feeService from "../../assets/services/fee.service";
import DatePicker from "../form/DatePicker.vue";

export default {
  name: "FeeMaster",
  components: { DatePicker },
  data() {
    return {
      isLoading: false,
      fees: [],
      showModal: false,
      editingFee: {},
    };
  },
  computed: {
    fields() {
      let cols = [
        { key: "sno", label: "#" },
        { key: "fee_description", label: "Fee Type" },
        { key: "organ_type", label: "Organ Type" },
        { key: "amount", label: "Amount" },
        { key: "effective_from", label: "Effective From" },
        { key: "is_active", label: "Status" },
      ];
      if (this.isAdmin) {
        cols.push({ key: "actions", label: "Actions" });
      }
      return cols;
    },
  },
  methods: {
    async loadFees() {
      try {
        this.isLoading = true;
        let { data } = await feeService.getFeeMaster();
        this.isLoading = false;
        if (data.status && data.list) {
          this.fees = data.list;
        }
      } catch (error) {
        this.isLoading = false;
        this.$alert.show(error.message);
      }
    },
    editFee(fee) {
      this.editingFee = { ...fee };
      this.showModal = true;
    },
    async saveFee() {
      try {
        this.$loader.show();
        let { data } = await feeService.updateFeeMaster({
          fee_id: this.editingFee.fee_id,
          amount: this.editingFee.amount,
          effective_from: this.editingFee.effective_from,
        });
        this.$loader.hide();
        if (data.status) {
          this.$alert.show("Fee updated successfully");
          this.showModal = false;
          await this.loadFees();
        } else {
          this.$alert.show(data.msg);
        }
      } catch (error) {
        this.$loader.hide();
        this.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.loadFees();
  },
};
</script>
